export default "__VITE_ASSET__CYO70DA$__"